import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Necesito experiencia previa en negocios?',
  answer: 'No. Este Blueprint fue diseñado para empezar desde cero con claridad y sin confusión técnica.'
}, {
  question: '¿Funciona para cualquier tipo de negocio?',
  answer: 'Sí. Los principios de Mayordomía y los sistemas de marketing aplican para servicios físicos, digitales y de cualquier industria.'
}, {
  question: '¿Cómo recibo el producto?',
  answer: 'Al completar tu pago recibirás un email con el enlace de descarga inmediata. En menos de 2 minutos ya tendrás todo en tu dispositivo.'
}, {
  question: '¿Y si no me gusta?',
  answer: 'Tienes 7 días para pedir tu reembolso completo. Sin preguntas.'
}, {
  question: '¿Es bíblico querer prosperar económicamente?',
  answer: 'Absolutamente. Deuteronomio 8:18 dice que Dios nos da el poder para hacer las riquezas. La prosperidad con propósito es un mandato, no un pecado.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-white py-20 md:py-28 px-4" data-id="element-11">
      <div className="max-w-3xl mx-auto" data-id="element-12">
        <h2 className="text-3xl md:text-5xl text-navy mb-12 text-center" data-id="element-13">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-14">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-15">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left bg-gray-50 hover:bg-gray-100 transition-colors" data-id="element-16">
                <span className="font-bold text-navy text-lg pr-4" data-id="element-17">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-navy transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-18" />
              </button>

              <AnimatePresence data-id="element-19">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-20">
                    <div className="px-6 py-5 text-charcoal leading-relaxed bg-white border-t border-gray-200" data-id="element-21">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}